<script setup>
import moment from 'moment';
import { ref, computed, onMounted, onUnmounted, watch } from "vue";
import NumberInputPopup from "./NumberInputPopup.vue";

const data = ref(null);

const dataUrl = "https://script.google.com/macros/s/AKfycbxYq-IwlxsmaANO_Kqv1yjStHYBY0aJAbQJQqqBQKwL5M1bXuTlVc5_T9QmIQ3OR6AIug/exec";

const defaultValues = {
  weightBeforeRoast: '',
  weightAfterRoast: '',
  preheatTemperature: '',
  selectedRoastlevel: '',
  selectedProfile: '',
  selectedBean: '',
  firstPopTemperature: '',
  secondPopTemperature: ''
}

const state = ref({...defaultValues});

const firstPopTime = ref(0);
const secondPopTime = ref(0);

// state の変更を監視して、localStorage に保存
watch(state, (newState) => {
  localStorage.setItem('appState', JSON.stringify(newState));
  let tempSavedState = localStorage.getItem('_appState');
  if (tempSavedState) {
    localStorage.setItem('appState', tempSavedState);
    localStorage.removeItem('_appState');
  }
}, { deep: true });

const loadFromLocalStorage = () => {
  const savedState = localStorage.getItem('appState');
  if (savedState) {
    const _savedState = JSON.parse(savedState);
    _savedState['weightAfterRoast'] = '';
    _savedState['firstPopTemperature'] = '';
    _savedState['secondPopTemperature'] = '';
    state.value = _savedState;
  }
};

const crearInputData = () => {
  localStorage.setItem('_appState', JSON.stringify(state.value));
  state.value = {...defaultValues};
  reset();
};

const roastRatio = computed(() => {
  let ret = {};
  if (!!state.value.weightBeforeRoast && !!state.value.weightAfterRoast){
    ret.ratio = (parseInt(state.value.weightBeforeRoast) / (state.value.weightAfterRoast)).toPrecision(3);
    ret.ratioReverse = String((parseInt(state.value.weightAfterRoast) / (state.value.weightBeforeRoast) * 100).toPrecision(3)) + "%";
    return ret
  } else {
    return ''
  }
});

const activeKey = ref(null);
const isPopupOpen = ref(false);


const openPopup = (key) => {
  activeKey.value = key;
  isPopupOpen.value = true;
};


const apiResponse = ref();


onMounted(async () => {
  apiResponse.value = localStorage.getItem('apiResponse');
  if (apiResponse.value) {
    data.value = JSON.parse(apiResponse.value);
  } else {
    await getApiData();
  }
});

const getApiData = async () => {
  data.value = 0;
  try {
    const responses = await fetch(dataUrl, {
      method: 'GET',
    });
    data.value = await responses.json();
    localStorage.setItem('apiResponse', JSON.stringify(data.value));
  } catch (error) {
    console.error("APIエラー:", error);
  }
};


const submitRoastInfo = async () => {
  const postData = {
    '焙煎日': moment().format('YYYY/MM/DD HH:mm:ss'),
    '豆ID': state.value.selectedBean['豆ID'],
    '焙煎前g': state.value.weightBeforeRoast,
    '焙煎後g': state.value.weightAfterRoast,
    '焙煎度': state.value.selectedRoastlevel,
    '開始温度': state.value.preheatTemperature,
    '1ハゼ温度': state.value.firstPopTemperature,
    '2ハゼ温度': state.value.secondPopTemperature,
    '1ハゼ時間': formatTime(firstPopTime.value),
    '2ハゼ時間': formatTime(secondPopTime.value),
    '焙煎完了時間': formatTime(time.value),
    '目標プロファイル': state.value.selectedProfile['プロファイル名'],
    '焙煎指数': String(roastRatio.value.ratio),
    '焙煎指数逆数': String(roastRatio.value.ratioReverse)
  };
  try {
    const response = await fetch(dataUrl, {
      method: 'POST',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: JSON.stringify(postData),
      mode: "no-cors"
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const result = await response.json();
    console.log(result);
    alert("成功しました！");
  } catch (error) {
    console.log(error.message);
  }
}

const time = ref(0); // 時間を保持するリアクティブな変数
const isRunning = ref(false); // ストップウォッチが動いているかどうか
let timer = null; // タイマーID

function formatTime(_time) {
  let minus = '';
  if (_time < 0){
    _time = _time * -1;
    minus = '-';
  }
  const minutes = String(Math.floor(_time / 60)).padStart(2, '0');
  const seconds = String(Math.floor(_time % 60)).padStart(2, '0');

  return `${minus}${minutes}:${seconds}`;
}


function roastLevelText(ratio){
  if(ratio<1.125){
    return 'ライトロースト（〜1.125）';
  } else if(ratio<1.15){
    return 'シナモンロースト（1.125〜1.15）';
  } else if(ratio<1.175){
    return 'ミディアムロースト（1.15〜1.175）';
  } else if(ratio<1.2){
    return 'ハイロースト（1.175〜1.20）';
  } else if(ratio<1.225){
    return 'シティロースト（1.20〜1.225）';
  } else if(ratio<1.25){
    return 'フルシティロースト（1.225〜1.25）';
  } else if(ratio<1.275){
    return 'フレンチロースト（1.25〜1.275）';
  } else {
    return 'イタリアンロースト（1.275〜）';
  }
}

const targetTemperature = computed(() => {
  if (!!time.value && !!state.value.selectedProfile){
    return JSON.parse(state.value.selectedProfile["温度推移"])[Math.floor(time.value / 60)];
  } else {
    return '?'
  }
});

const fireLevel = computed(() => {
  if (!!time.value && !!state.value.selectedProfile){
    return JSON.parse(state.value.selectedProfile["火力"])[Math.floor(time.value / 60)];
  } else {
    return '?'
  }
});


const remainingTimeToFirstPop = computed(() => {
  if (firstPopTime.value != 0) {
    return state.value.selectedProfile["1ハゼ時間"] * 60 - firstPopTime.value;
  } else {
    return state.value.selectedProfile["1ハゼ時間"] * 60 - time.value;
  }
})


const remainingTimeToSecondPop = computed(() => {
  if (secondPopTime.value != 0) {
    return state.value.selectedProfile["2ハゼ時間"] * 60 - secondPopTime.value;
  } else {
    return state.value.selectedProfile["2ハゼ時間"] * 60 - time.value;
  }
})



// スタート・ストップを切り替えるメソッド
const startStop = () => {
  if (isRunning.value) {
    clearInterval(timer);
    stopAudio();
  } else {
    startAudio();
    timer = setInterval(() => {
      time.value += 0.01; // 毎回0.01秒増加
    }, 10);
  }
  isRunning.value = !isRunning.value;
};

// リセットするメソッド
const reset = () => {
  clearInterval(timer);
  time.value = 0;
  isRunning.value = false;
  firstPopTime.value = 0;
  secondPopTime.value = 0;
};

const recordPop = (num) => {
  switch (num){
    case 1:
      firstPopTime.value = time.value;
      break;
    case 2:
      secondPopTime.value = time.value;
      break;
  }
};

// コンポーネントのアンマウント時にタイマーをクリア
onUnmounted(() => {
  clearInterval(timer);
});

const video = document.createElement('video');
video.src = '/output.mp4';  // 無音ビデオファイルのパス
// video.muted = true;  // 無音で再生
video.loop = true;

const startAudio = () => {
  video.play();
};

const stopAudio = () => {
  video.pause();
};


const showImagesPopup = ref(false);

const openImagesPopup = () => {
  showImagesPopup.value = true;
  document.body.style.overflow = 'hidden'; // スクロールを無効化
};

const closeImagesPopup = () => {
  showImagesPopup.value = false;
  document.body.style.overflow = ''; // スクロールを元に戻す
};
</script>

<template>
  <div>
    <div v-if="data">
      <button style="margin-right: 10px;" @click="loadFromLocalStorage">保存した値を復元</button>
      <button @click="crearInputData">値をクリア</button>
      <select v-model="state.selectedRoastlevel" :class="!!state.selectedRoastlevel ? 'selected':''">
        <option disabled value="">焙煎度</option>
        <option v-for="roastlevel in data['roastlevel']" 
          v-bind:value="roastlevel['焙煎度']" 
          v-bind:key="roastlevel['焙煎度']">
        {{ roastlevel['焙煎度'] }}
        </option>
      </select>
      <select v-model="state.selectedProfile" :class="!!state.selectedProfile ? 'selected':''">
        <option disabled value="">目標焙煎プロファイル</option>
        <option v-for="profilegoal in data['profilegoals']" 
          v-bind:value="profilegoal" 
          v-bind:key="profilegoal['プロファイル名']">
        {{ profilegoal['プロファイル名'] }}
        </option>
      </select>
      <select v-model="state.selectedBean" :class="!!state.selectedBean ? 'selected':''">
        <option disabled value="">豆</option>
        <option v-for="bean in data['beans']" 
          v-bind:value="bean"
          v-bind:key="[bean['生産国'],bean['品種'],bean['精製方法'],bean['購入店舗']].join(' ')">
        {{ [bean['生産国'],bean['品種'],bean['精製方法'],bean['購入店舗'],bean['残量']].join(' ') }}
        </option>
      </select>
      
      <div v-if="state.weightBeforeRoast">焙煎前g</div>
      <input
        type="text"
        v-model="state.weightBeforeRoast"
        readonly
        @focus="openPopup('weightBeforeRoast')"
        class="input-box justifiy-content-center"
        placeholder="焙煎前g"
      />

      <NumberInputPopup v-model="state[activeKey]" :isOpen="isPopupOpen" @close="isPopupOpen = false" />

      <div class="stopwatch">
        <div>
          <p>予熱目標温度: {{ !!state.selectedProfile ? state.selectedProfile["予熱温度"] : "?" }}℃</p>

          <div v-if="state.preheatTemperature">予熱温度</div>
          <input
            type="text"
            v-model="state.preheatTemperature"
            readonly
            @focus="openPopup('preheatTemperature')"
            class="input-box justifiy-content-center"
            placeholder="予熱温度"
          />
        </div>
        <div class="time-display">
          <h1>{{ formatTime(time) }}</h1>
        </div>
        <div>
          <p>現在の目標温度: {{ targetTemperature }}℃（火力: {{ fireLevel }}）</p>
        </div>
        <div class="controls">
          <button @click="startStop" :disabled="
            !!!state.selectedRoastlevel || !!!state.selectedBean || !!!state.selectedProfile || !!!state.weightBeforeRoast || !!!state.preheatTemperature
            ">{{ isRunning ? '停止' : '開始' }}</button>
          <button @click="reset" :disabled="!time">リセット</button>
          <br>
          <button @click="recordPop(1)" :disabled="!isRunning">1ハゼ</button>
          <button @click="recordPop(2)" :disabled="!isRunning">2ハゼ</button>
        </div>
        <div>1ハゼ時間: {{ firstPopTime ? formatTime(firstPopTime) : "?" }} ＜目標: {{ !!state.selectedProfile ? state.selectedProfile["1ハゼ時間"] : "?" }}分（{{ remainingTimeToFirstPop ? formatTime(remainingTimeToFirstPop) : "?" }}分後）＞</div>
        <div>2ハゼ時間: {{ secondPopTime ? formatTime(secondPopTime) : "?" }} ＜目標: {{ !!state.selectedProfile ? state.selectedProfile["2ハゼ時間"] : "?" }}分（{{ remainingTimeToSecondPop ? formatTime(remainingTimeToSecondPop) : "?" }}分後）＞</div>
        <div v-if="state.firstPopTemperature">1ハゼ温度</div>
        <input
          type="text"
          v-model="state.firstPopTemperature"
          readonly
          @focus="openPopup('firstPopTemperature')"
          class="input-box justifiy-content-center"
          placeholder="1ハゼ温度"
        />
        <div v-if="state.secondPopTemperature">2ハゼ温度</div>
        <input
          type="text"
          v-model="state.secondPopTemperature"
          readonly
          @focus="openPopup('secondPopTemperature')"
          class="input-box justifiy-content-center"
          placeholder="2ハゼ温度"
        />
      </div>

      <input
        type="text"
        v-model="state.weightAfterRoast"
        readonly
        @focus="openPopup('weightAfterRoast')"
        class="input-box"
        placeholder="焙煎後g"
      />
      <div v-if="!!roastRatio">焙煎指数：{{ roastRatio.ratio }}（{{ roastRatio.ratioReverse }}）</div>
      <div v-if="!!roastRatio">{{ roastLevelText(roastRatio.ratio) }}</div>
      <div>
        <button @click="submitRoastInfo()" :disabled="!!isRunning || !state.selectedRoastlevel || !state.selectedBean || !state.selectedProfile || !state.weightBeforeRoast || !firstPopTime || !state.weightAfterRoast || !state.preheatTemperature || !state.firstPopTemperature">結果を送信</button>
      </div>
      <div>
        <button @click="openImagesPopup">ポップアップを開く</button>

        <div v-if="showImagesPopup" class="overlay" @click.self="closeImagesPopup">
          <div class="popup">
            <img src="/roast_ratio.png" alt="">
            <button @click="closeImagesPopup">閉じる</button>
          </div>
        </div>
      </div>
      <div>
        <button @click="getApiData()">APIデータ再取得</button>
      </div>

    </div>
    <div v-else>データを取得中...</div>
  </div>
</template>


<style scoped>

input {
  width: 200px;
  padding: 10px;
  font-size: 18px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 5px;
}

select {
  width: 270px;
  padding: 10px;
  font-size: 18px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 5px;
  cursor: pointer;
  background-color: #FFF;
  margin-top: 5px;

  &.selected {
    background-color: #ccc;
  }
}

button {
  color: #fff;
  font-size: 18px;
  margin-top: 5px;
  border: 1px solid #795548;
  border-radius: 5px;
  background-color: #795548;
  padding: 5px 10px;
  &:disabled {
    background-color: #ccc;
    border: 1px solid #ccc;
}
}

.stopwatch {
  text-align: center;
  font-family: Arial, sans-serif;
}

.controls button {
  margin: 10px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* 半透明の背景 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup {
  background: white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  img {
    width: 100%;
    height: auto;
  }
}
</style>